import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/management/cameraIcon.svg'
import _imports_2 from '@/assets/img/management/videoIcon.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-e91dd96e")

_pushScopeId("data-v-e91dd96e")
const _hoisted_1 = { class: "genericPadding hasHeader hasFooter bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "fs_12 greyBlue"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = { class: "postContainer" }
const _hoisted_7 = { class: "postLoader" }
const _hoisted_8 = { class: "d-flex align-items-center mb-4" }
const _hoisted_9 = { class: "userImage" }
const _hoisted_10 = { class: "fs_13 greyBlue d-block ln_12 mb-1" }
const _hoisted_11 = { class: "fs_10 greyBlue d-block ln_12" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center mt-3" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "me-2"
  }),
  /*#__PURE__*/_createVNode("img", { src: _imports_2 })
], -1)
const _hoisted_13 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_14 = { class: "fs_12 d-block" }
const _hoisted_15 = {
  key: 1,
  class: "fs_12 grey d-block"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_17 = { class: "footerButtonContainer" }
const _hoisted_18 = { class: "d-flex align-items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_uose_writer = _resolveComponent("uose-writer")!
  const _component_preview_post_attachment = _resolveComponent("preview-post-attachment")!
  const _component_file_selector = _resolveComponent("file-selector")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      (_ctx.title)
        ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.title), 1))
        : (_openBlock(), _createBlock(_component_localized_text, {
            key: 1,
            localizedKey: "app_creaunpost",
            text: "Crea un post",
            class: "fs_12 greyBlue"
          })),
      _hoisted_5
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _withDirectives(_createVNode("div", _hoisted_9, null, 512), [
            [_directive_userimage, _ctx.$store.state.getUserImage(_ctx.$store.state.user.identifier)]
          ]),
          _createVNode("div", null, [
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$store.state.user.name), 1),
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$filters.date(_ctx.todayDate, "DD MMMM yyyy - HH:mm")), 1)
          ])
        ]),
        _createVNode(_component_uose_writer, {
          modelValue: _ctx.localVm.text,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.localVm.text = $event)),
          placeholderText: 'Scrivi qualcosa',
          placeholderKey: 'app_scriviqualcosa',
          "max-height": 200
        }, null, 8, ["modelValue"]),
        _createVNode(_component_preview_post_attachment, {
          preview: _ctx.preview,
          onRemoveAttachment: _ctx.removeAttachment
        }, null, 8, ["preview", "onRemoveAttachment"]),
        _createVNode(_component_file_selector, {
          modelValue: _ctx.localVm.attachment,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.localVm.attachment = $event)),
          accept: ".jpg, .jpeg, .png, .wav, .mp4, .pdf, .ppt, .mp3"
        }, {
          default: _withId(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mt-4 mb-2",
      localizedKey: "app_selezionauntag",
      text: "Seleziona un tag"
    }),
    (_ctx.tags.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tags, (tag, index) => {
            return (_openBlock(), _createBlock("div", {
              class: ["filterTab", _ctx.localVm.tag.tag == tag.tag ? 'active' : ''],
              key: index,
              onClick: ($event: any) => (_ctx.localVm.tag = tag)
            }, [
              _createVNode("span", _hoisted_14, _toDisplayString(tag.tag), 1)
            ], 10, ["onClick"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("span", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_localized_text, {
            localizedKey: "app_nessunTagPresente",
            text: "Nessun tag presente",
            class: "ms-1"
          })
        ])),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode("button", {
          type: "button",
          class: "genericButton bgWhite w-100 me-1",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_localized_text, {
            class: "fs_14 spaceCadet",
            localizedKey: "app_annulla",
            text: "Annulla"
          })
        ]),
        _createVNode("button", {
          type: "button",
          disabled: _ctx.localVm.tag.tag == '' || _ctx.localVm.text == '',
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.doPost())),
          class: "genericButton bgGreyBlue w-100 ms-1"
        }, [
          _createVNode(_component_localized_text, {
            class: "fs_14 white",
            localizedKey: "app_conferma",
            text: "Conferma"
          })
        ], 8, ["disabled"])
      ])
    ])
  ]))
})